






























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from "@/components/User";
import DialogUI from "@/components/shared/DialogUI.vue";
import { IDialog } from "@/components/shared/types";
//import { mapState, mapMutations } from 'vuex';

import Menu from "./home/Menu.vue";
import Apps from "./home/Apps.vue";
import Service from "./home/Service.vue";
import AboutUs from "./home/AboutUs.vue";
import News from "./home/News.vue";
import ContactUs from "./home/ContactUs.vue";
import Dashboard from "./home/Dashboard.vue";
import UserLogin from "./home/UserLogin.vue";
import UserRegistration from "./home/UserRegistration.vue";
import OrgRegistration from "./home/OrgRegistration.vue";
import UserProfile from "./home/UserProfile.vue";
import UserForgotPassword from "./home/UserForgotPassword.vue";
import AdminUsers from "./home/Admin.Users.vue";
import AdminUserLogs from "./home/Admin.UserLogs.vue";
import AdminAddUser from "./home/Admin.AddUser.vue";
import AdminAddNews from "./home/Admin.AddNews.vue";
import AdminUploadCropData from "./home/Admin.UploadCropData.vue";
import Welcome from "./home/Welcome.vue";
import Confirm from "./home/Confirm.vue"

@Component({
  components: {
    "v-dialog": DialogUI,
    Menu,
    mapping: Apps,
    measuring: Apps,
    modeling: Apps,
    monitoring: Apps,
    managing: Apps,
    service: Service,
    aboutus: AboutUs,
    news: News,
    contactus: ContactUs,
    dashboard: Dashboard,
    login: UserLogin,
    registeruser: UserRegistration,
    userprofile: UserProfile,
    forgotpassword: UserForgotPassword,
    welcome: Welcome,
    confirm: Confirm, 
    admin: AdminUsers,
    adminuserlogs: AdminUserLogs,
    adminadduser: AdminAddUser,
    adminaddnews: AdminAddNews,
    uploadcropdata: AdminUploadCropData
  }
})
export default class Home extends Vue {
  wallpaper: number = 1;
  wallpaperInterval: any = null;
  thisYear = (new Date()).getFullYear() + 543;
  
  created() {
    let hash = window.location.hash;
    if (hash) {
      if (hash.indexOf('?')>0) {
        //has always starts with '#' and exists at the end of url.
        //however, it may be wrongly placed before query parameters
        //so we need to detect and extract it correctly
        hash = hash.substring(0,hash.indexOf('?'));
      }
      hash = hash.substr(1); // remove #
    } else {
      hash = window.location.pathname.substr(1);
    }
    if (hash) {
      this.SelectedApp = hash;
    }
  }

  mounted() {
    this.wallpaperInterval = setInterval(() => {
      this.wallpaper = (this.wallpaper==5) ? 1 : (this.wallpaper+1);
    },20000);
  };

  beforeDestroy() {
    if (this.wallpaperInterval!==null) {
      clearInterval(this.wallpaperInterval);
    }
  }

  MenuData: any = null;
  changeMenu(menu) {
    this.$store.commit('notifyChange', {
      SelectedApp: menu.name
    });
    this.MenuData = menu.data || null;
  }

  closeDialog(result:"ok" | "cancel" | "close") {
    let OnClose = this.Dialog.OnClose;
    let close = true;
    if (OnClose) {
      close = OnClose(result);
    }
    if (close!==false) {
      this.$store.commit('notifyChange', {
        Dialog: {
          Message: null,
          show: false,
          wait: false
        }
      });
    }
  }

  get Dialog() : IDialog {
    return this.$store.getters.Dialog;
  }

  get showBackdrop() : boolean {
    return this.$store.getters.ShowBackdrop;
  }

  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  }

  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  }

  scrollTo() {
    setTimeout(()=>{
      let element = this.$refs['content'];
      if (element && element['offsetTop']>10) {
        window.scroll({
          top: (element['offsetTop'] - 4),
          left: 0,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  gotoApp(app:string) {
    // in case that we are already in window 'softoo'
    if (window.name==app) {
      this.$store.commit('notifyChange', {
        Page: app
      });
    } else {
      let url;
      if (window[app]) {
        url = '';
      } else {
        url = window.location.protocol + '//' + 
              window.location.hostname + 
              (window.location.port ? ':' + window.location.port : '');
        url += '/' + (app.match(/gisagromap/i) ? 'map' : app);
      }
      window.name = 'GISagro';
      window[app] = window.open(url, app);
      window[app].focus();
    }
  };
}
